import { FIELDS } from './constants';
import { genderReversMap } from './genderHelper';
import * as MapperHelper from './mapperHelper';

const patchLivingAddress = ({ state, target }) => {
  const {
    [FIELDS.LIVING_ADDRESS]: fiasValue = '',
    [FIELDS.LIVING_ADDRESS_DA_DATA_INFO]: daDataInfo,
    [FIELDS.LIVING_ADDRESS_FROM_DA_DATA]: isLivingAddressFromDadata,
    [FIELDS.LIVING_ADDRESS_EQUALS]: livingAddressEquals,
  } = state;
  const { building: buildingNumber } = daDataInfo ?? {};

  target.livingAddress ??= {};
  target.livingAddress.address ??= {};

  if (typeof isLivingAddressFromDadata === 'boolean') {
    Object.assign(target.livingAddress, { isLivingAddressFromDadata });
  }

  if (typeof livingAddressEquals === 'boolean') {
    Object.assign(target, { livingAddressEquals });
  }

  if (!daDataInfo) {
    return;
  }

  const { index: indexNumber } = daDataInfo;

  Object.assign(target.livingAddress.address, {
    ...daDataInfo,
    buildingNumber,
    fiasValue,
    indexNumber,
  });
};

const patchPassport = ({ state, target }) => {
  const {
    [FIELDS.BIRTH_PLACE]: birthPlace,
    [FIELDS.PASSPORT_CHANGED]: changed,
    [FIELDS.PASSPORT_ISSUE_DATE]: issueDate,
    [FIELDS.PASSPORT_ISSUER]: issuer,
    [FIELDS.PASSPORT_ISSUER_CODE]: issuerCode,
    [FIELDS.PASSPORT_SERIES_AND_NUMBER]: serialNum,
    [FIELDS.PREVIOUS_PASSPORT_ISSUE_DATE]: previousIssueDate,
    [FIELDS.PREVIOUS_PASSPORT_NUMBER]: previousNumber,
    [FIELDS.PREVIOUS_PASSPORT_SERIES]: previousSeries,
  } = state;

  target.passport ??= {};

  Object.assign(target.passport, {
    ...MapperHelper.passportSplit(serialNum),
    birthPlace,
    issueDate: MapperHelper.dateFormmatter(issueDate, true),
    issuer,
    issuerCode,
  });

  if (typeof changed === 'boolean') {
    Object.assign(target.passport, {
      changed,
      previousIssueDate: MapperHelper.dateFormmatter(previousIssueDate, true),
      previousNumber,
      previousSeries,
    });
  }
};

const patchRegistrationAddress = ({ state, target }) => {
  const {
    [FIELDS.REGISTRATION_ADDRESS]: fiasValue = '',
    [FIELDS.REGISTRATION_ADDRESS_DA_DATA_INFO]: daDataInfo,
    [FIELDS.REGISTRATION_ADDRESS_FROM_DA_DATA]: isRegistrationAddressFromDadata,
    [FIELDS.REGISTRATION_INDEX]: indexNumber,
  } = state;
  const { building: buildingNumber } = daDataInfo ?? {};

  target.registrationAddress ??= {};
  target.registrationAddress.address ??= {};

  Object.assign(target.registrationAddress.address, {
    ...daDataInfo,
    buildingNumber,
    fiasValue,
    indexNumber,
  });

  if (typeof isRegistrationAddressFromDadata === 'boolean') {
    Object.assign(target.registrationAddress, { isRegistrationAddressFromDadata });
  }
};

const patchSecondDocument = ({ state, target }) => {
  const {
    [FIELDS.DRIVING_EXPERIENCE]: drivingExperience,
    [FIELDS.IS_DRIVER]: isDriverState,
    [FIELDS.DRIVING_LICENSE_IS_FIRST]: isFirstLicense,
    [FIELDS.DRIVING_LICENSE_ISSUE_DATE]: licenseDate,
    [FIELDS.DRIVING_LICENSE_SERIES_AND_NUMBER]: licenseSeriaNum,
    [FIELDS.PREVIOUS_DRIVING_LICENSE_ISSUE_DATE]: prevLicenseDate,
    [FIELDS.PREVIOUS_DRIVING_LICENSE_SERIES_AND_NUMBER]: prevLicenseSeriaNum,
  } = state;

  target.secondDocument ??= {};
  target.secondDocument.currentSecondDocumentTypeSysName ||= '2nd_driver';

  const isDriver = !Object.prototype.hasOwnProperty.call(state, FIELDS.IS_DRIVER) || isDriverState;

  if (!isDriver) {
    return;
  }

  target.secondDocument.driverLicense ??= {};

  const { number = '', series = '' } = MapperHelper.splitDriverLicense(licenseSeriaNum);
  const { number: previousNumber = '', series: previousSeries = '' } =
    MapperHelper.splitDriverLicense(prevLicenseSeriaNum);
  const issueDate = MapperHelper.dateFormmatter(licenseDate, true) || '';
  const previousIssueDate = MapperHelper.dateFormmatter(prevLicenseDate, true) || '';

  Object.assign(target.secondDocument.driverLicense, {
    id: null,
    issueDate,
    number,
    previousIssueDate,
    previousNumber,
    previousSeries,
    series,
    startDate: previousIssueDate,
  });

  if (typeof drivingExperience === 'number') {
    Object.assign(target.secondDocument.driverLicense, { drivingExperience });
  }

  if (typeof isFirstLicense === 'boolean') {
    Object.assign(target.secondDocument.driverLicense, { changed: !isFirstLicense });
  }
};

export const frontToBackCustomer = (fc, model = {}) => {
  model.personalInformation = {
    ...model?.personalInformation,
    ...MapperHelper.fioSplit(fc[FIELDS.FULL_NAME]),
    genderSysName: genderReversMap[fc[FIELDS.GENDER]]?.toLowerCase() ?? genderReversMap[0],
    birthDate: MapperHelper.dateFormmatter(fc[FIELDS.BIRTHDATE], true),
  };

  model.contacts = {
    ...model?.contacts,
    mobilePhone: fc[FIELDS.MOBILE_PHONE],
    email: fc[FIELDS.EMAIL],
  };

  const patchArgument = { state: fc, target: model };

  patchLivingAddress(patchArgument);
  patchPassport(patchArgument);
  patchRegistrationAddress(patchArgument);
  patchSecondDocument(patchArgument);

  return model;
};
